"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../shared");

var _shared2 = _interopRequireDefault(require("./shared"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var H4 = _styledComponents["default"].h4.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "h4__H4",
  componentId: "sc-13zm03c-0"
})(["", ";"], _shared2["default"]);

var _default = H4;
exports["default"] = _default;